import React from "react";
import Card from "../components/Card";
import StackBar from "../components/StackBar";

import { ProjectsArray } from "../assets/projects.js";

const Projects = () => {
  return (
    <div className="projects mt-5">
      <div className="row justify-content-center">
        <div className="col-10 mt-5">
          <div className="fs-1 myfont">Projects & Skills:</div>
        </div>
      </div>
      <div className="row justify-content-center mt-3">
        <div className="col-10 d-flex flex-wrap">
          {ProjectsArray.map((project) => (
            <Card key={project.id} project={project} />
          ))}
        </div>
      </div>
      <div className="row justify-content-center mt-3">
        <div className="col-10">
          <div className="myfont_p">
            <StackBar />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
